import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useBrandGuidelines } from "@modules/ECMS/CORPORATE/Forms/MediaCentre/Media.hook";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { Button, Tabs } from "antd";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { useHasAccess } from "~/Hooks/useHasAccess";
import { post, put } from "~/Services";
import { fields } from "../MediaCentre/constants";
import { corporateHost } from "~/Utils";
import { ManagementTeam } from "./ManagementTeam/ManagementTeam";
import { Icon } from "@iconify/react";
import { CompanyStructure } from "./CompanyStructure/CompanyStructure";
import { BoardOfDirectors } from "./BoardOfDirectors/BoardOfDirectors";
export const Organization = () => {
  const navigate = useNavigate();
  const query = useQuery();
  
  useEffect(() => {
    if(query.get('id')){
      return;
    }
    if (!query.get("activeTab")) {
        navigate(`/dedicated/corporate/organization?activeTab=boardOfDirectors&subActiveTab=boardOfDirectorsPage`, {
          replace: true,
        });
    } else{
      if(query.get('activeTab')==='boardOfDirectors'){
        navigate(`/dedicated/corporate/organization?activeTab=boardOfDirectors&subActiveTab=${query.get('subActiveTab')||'boardOfDirectorsPageHeading'}`, {
          replace: true,
        });
      }
      if(query.get('activeTab')==='managementTeam'){
        navigate(`/dedicated/corporate/organization?activeTab=managementTeam&subActiveTab=${query.get('subActiveTab')||'managementTeamPageHeading'}`, {
          replace: true,
        });
      }
      if(query.get("activeTab")==='companyStructure'){
        navigate(`/dedicated/corporate/organization?activeTab=companyStructure&subActiveTab=${query.get('subActiveTab')||'companyStructurePageContent'}`, {
          replace: true,
        });
      }
    }
  }, [query.get('activeTab'), query.get('subActiveTab')]);
  const items = [
    {
      label: "Board of Directors",
      key: "boardOfDirectors",
      children: (
        <BoardOfDirectors/>
      ),
    },
    {
      label: "Management Team",
      key: "managementTeam",
      children: (
        <ManagementTeam/>
      ),
    }, 
    // {
    //   label: "Company Structure",
    //   key: "companyStructure",
    //   children: (
    //     <CompanyStructure/>
    //   ),
    // },
  ];

  const handleProductManagement=(activeTab:any, subActiveTab:any)=>{
    if(activeTab === 'managementTeam' && subActiveTab==='managementTeamPageContent') {
      return (<Button
      onClick={() => {
        navigate("/dedicated/corporate/organization/managementTeam/add");
      }}
      icon={<Icon icon={"lucide:plus"} />}
      >
        Add Management Team
      </Button>
      )
    } else if(activeTab === 'boardOfDirectors' && subActiveTab==='boardOfDirectorsPageContent') {
      return (<Button
      onClick={() => {
        navigate("/dedicated/corporate/organization/boardOfDirectors/add");
      }}
      icon={<Icon icon={"lucide:plus"} />}
      >
        Add Board of Directors
      </Button>
      )
    } 
  }

  return (
    <ContentWrapper
      title={"Organization"}
      actionItems={
        handleProductManagement(query?.get('activeTab'), query?.get('subActiveTab'))
      }
    >
      <Tabs
        activeKey={query?.get("activeTab") || ""}
        items={items}
        onChange={(activeKey) => {
          navigate(`${window.location.pathname}?activeTab=${activeKey}`);
        }}
      ></Tabs>
    </ContentWrapper>
  );
};
